import { render, staticRenderFns } from "./matchDynamics.vue?vue&type=template&id=fca02460&scoped=true&"
import script from "./matchDynamics.vue?vue&type=script&lang=js&"
export * from "./matchDynamics.vue?vue&type=script&lang=js&"
import style0 from "./matchDynamics.vue?vue&type=style&index=0&id=fca02460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca02460",
  null
  
)

export default component.exports